import styled from 'styled-components';

export const SliderWrap = styled.div<{isB2C?: boolean}>`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	gap: 1rem;
	@media (min-width:935px){
	&.eqadjustWrap{
		display: grid;
		grid-template-columns: 65% 35%;
	}
 }

 @media (max-width:934px){
	&.eqadjustWrap{
		flex-wrap: wrap;
	}
 }

	@media screen and (max-width:540px) {
	&.EnableSliderWrapper{
		flex-wrap: wrap;
		gap: 10px;
		align-items: center;
		}
	}

		

	// @media (max-width: 480px) {
	// 	// flex-direction: column;
	// 	align-items: flex-start;
	// }
		
		@media (max-width: 410px) {
&.NonEnableSliderWrapper{
		flex-wrap: wrap;
		// align-items: center;
		flex-direction: column;
		align-items: start;
	}

	
	}

	h3 {
		color: var(--subHeadingColor);
    font-weight: 400;
    font-size: 1.063rem;
    margin: 0;
		white-space: nowrap;

		@media (max-width: 1325px) {
			font-size: 1rem;
		}
		@media (max-width: 500px) {
			font-size: 1rem;
		}
	}
	.sliderWithName{
		display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	gap: 0.313rem;
		@media (max-width: 840px) {
			margin-left: ${(props)=> props?.isB2C ? '0px': '30px'};
			justify-content: ${(props)=> props?.isB2C ? 'flex-start': 'flex-end'};
		}
		@media (max-width: 480px) {
		margin-left:0px}
		@media (max-width: 500px) {
			align-items: center;
			width:100%;
			gap: 0.5rem;
		
		}
	}

	.mobile-offset{

	}
`;

export const RangeValueWrap = styled.div`
		max-width: 350px;
		width: 100%;
		@media (max-width: 840px) {
			width: 74%
		}
`;

export const RangeWrap = styled.div`
	display: flex;
	width:100%;
	flex-direction: row;
	align-items: center;
	@media (max-width: 935px) {
		justify-content: flex-start;
	}
		@media (max-width: 840px) {
		justify-content: flex-end;
	}
`;

export const RangePercentage = styled.div`
	display: flex;
	justify-content: flex-start;
	color: #999;
	padding-top: 2px;
	margin-right: 8px;
	min-width:30px;

	@media (max-width: 540px) {
	margin-right: 5px;
	min-width: 26px;
	}
`;

export const ToolHeaderWrap= styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 10px;


	@media (max-width: 935px) {
		margin: 0 auto !important;
	}
`;

export const ToolHeaderMainWrap= styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.45rem;
	@media (max-width: 1290px){
	  gap: 0.45rem;
	}

	@media (max-width: 1024px) {
	&.NonView{

	width: 100%;
	  align-self: flex-end;
	  align-items: end;
    justify-content: end;
	.mobile-view{
			width:auto
		}
	}
		
		    
		width:100%;
		.mobile-view{
			// 
		}
			&.EnableModeView{
			flex-direction: column;
			align-items: start;
		.mobile-view{
			flex-direction: row;
			align-self: end;
			justify-content: end;
			width: 100%;
			padding-right: 0;
		}
			}
	}
			@media (max-width: 840px) {
		&.NonView {
        width: 100%;
				justify-content: space-between;
       
    }
		}
			@media (max-width: 560px) {
		&.NonView {
       flex-direction:column;
			 align-items:center;
			 .mobile-view {
       align-items:center;
			 align-self: center;
    }
       
    }
	@media (max-width: 760px) {
		// flex-direction: column;
		align-items: start;
		.mobile-view{
			width: auto;
			flex-direction: row;
			align-self: end;
		}
	}	
`;
export const StripButoonWrap= styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`;

export const ToolZoomWrap= styled.div`
position:relative;
height: 100%;
width: 100%
`;
export const ToolHeader= styled.div`
 	display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
	width: 100%;
	&.EnableModeViewWrapper{
		@media (max-width: 1024px){
			overflow-x: auto;
		}
	}

	@media (max-width: 840px) {
		flex-direction:column-reverse;
		 gap: .75rem;
	}
	&.NonViewWrapper{
		@media (max-width: 840px) {
			.NonEditViewWrapper{
				display :none
			}
		}
	}
	&.EnableModeViewWrapper{
	@media (max-width: 1120px) {
		// flex-direction: column;
		.EnableModeView{
			flex-direction: row;
			align-self: end;
		}
	}
	@media (max-width: 840px) {
			flex-direction: column-reverse;
		.EnableModeView{
			// overflow:auto;
			// padding-bottom:5px
		}	
	}
		@media (max-width: 480px) {
			.EnableModeView{
				flex-wrap: wrap;
        justify-content: space-between;
			}
		}

 }
		@media (max-width: 1024px) {
			&:not(.roof-tool){
				flex-wrap: wrap;
			}
		}
	&.roof-tool{
		@media (max-width: 840px) {
				flex-direction: row;
				.NonEnableSliderWrapper,
				.EnableSliderWrapper{
					width: auto;
				}
		}
		@media (max-width: 560px) {
			.NonEnableSliderWrapper{
				width: auto;
			}
			.EnableSliderWrapper{
				width: 100%;
			}
				flex-direction: column-reverse;	
		}		
	}		

`;
export const EditButtonLaptop= styled.div`
display: none ;
@media (min-width: 840px) {
	display: flex;
	}
`;
export const EditButtonMobile= styled.div`

display: flex;
@media (min-width: 840px) {
	display: none ;
	}
	@media (max-width: 480px) {
		// flex-direction:column;
		// gap:1rem
		}
`;
export const EditButtonWrap= styled.div`
	@media (max-width: 540px) {
	margin-top:5px}

`;

export const AdjustPanelWrap= styled.div<{isB2C?: boolean}>`
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: 100%;
		gap: 0.313rem;
		@media (max-width: 840px) {
			margin-left:${(props) => (props?.isB2C ? '0px': '30px')};
		}
		@media (max-width: 480px) {
			margin-left:0px;
		}
		@media (max-width: 500px) {
			align-items: flex-start;
			width:100%;
			gap: 0.5rem;
		}
`;
export const AdjustPanelHeading= styled.div`
		display: flex;
		width: auto;
		justify-content: space-between;
	`;

export const InfoText= styled.div`
		color: var(--textColor);
		font-size: .75rem;
		font-family: 'Inter';
		font-weight: 400;
		display:flex;
		flex-wrap:wrap;
		width: 100%;
		padding-left: 0;
		position: relative;
    top: -4px;
		span{
			display: contents;
			font-weight: bold;
		}
			@media (min-width:840px){
				padding-left: 1.35rem;
				padding-right: 2px;
			}
`;
export const MobileViewHeader= styled.div`
		display: flex;
		width: auto;
		flex-wrap: wrap;
		gap:.35rem;

`;

export const SliderWithToggleDiv = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap:wrap;
	width: 100%;
	justify-content: space-between;
	gap: 1rem;

	@media(min-width:720px){
		.panelColorToggle{
			
		}
	}
	
	@media(min-width:540px){
		.panelColorToggle{
			padding-left: 1.5rem;

			
		}
		flex-wrap:nowrap;
		
		
	}
	
`;

export const NonEditModeDiv = styled.div``;